import R from 'ramda';
import $ from 'jquery';
import React from 'react';
import Promise from 'bluebird';
import Modal from 'react-bootstrap/lib/Modal';
import Alert from 'react-bootstrap/lib/Alert';
import autoBind from '../../modules/autoBind';
import { validations } from 'common';
import Spinner from '../../modules/Spinner.jsx';
import Pagination from 'react-bootstrap/lib/Pagination';

export default class Licenses extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      numLicensesRequested: "",
      loadingLicenses: false,
      numLicenses: false
    };
  }
  componentDidMount() {
    this.fetchLicenses();
  }
  render() {
    return (
      <span>Licencias Disponibles: {this.state.numLicenses || 0}
        <input style={{ marginLeft: '10px' }} type="number" min="1" value={this.state.numLicensesRequested} onChange={(event) => this.setState({ numLicensesRequested: event.target.value })} placeholder="Solicitar licencias"/> 
        <input type="submit" value="Solicitar" onClick={this.addLicenses} disabled={this.state.numLicensesRequested === "" || this.state.loadingLicenses}/>
      </span>
    );
  }
  fetchLicenses() {
    return Promise.resolve($.ajax({ 
      url: this.props.resourceUrl,
    })).then(({licenses}) => this.setState({ numLicenses: licenses }))    
    .catch(() => this.setState({ numLicenses: 0 }));
  }
  addLicenses(event) {
    event.preventDefault();
    const num = this.state.numLicensesRequested;
    this.setState({ loadingLicenses: true, numLicensesRequested: "" });
    return Promise.resolve($.ajax({
      url: this.props.resourceUrl,
      method: 'POST',
      data: { licensesRequested: this.state.numLicensesRequested }
    })).catch(() => this.setState({ numLicensesRequested: num }))
    .finally(() => this.setState({ loadingLicenses: false }));
  }
}




// WEBPACK FOOTER //
// ./src/App/licenses/Licenses.jsx